import { useLocation } from "react-router-dom";
import { useUserDetailContext } from "../../../UserDetailContext";
import { useDispatch } from "react-redux";
import { getPersonalityTestResult } from "../../../../Redux/Reducers/numerologyReducer";
import { useEffect } from "react";
// import ParentComponent from "./ParentComponent";

const EducationAndCertificate = () => {
    // const dispatch = useDispatch();
    // const { userDetails, cardDetailsAll, cardStylesAll, cards } =
        // useUserDetailContext();

    // const objectId = localStorage.getItem('objectId');


  
    // const user_full_name = userDetails?.firstName + " " + userDetails?.lastName;
    return (
        // <ParentComponent className="d-flex align-items-center justify-content-center">
        <div style={{height:"85%",overflow:"hidden",scrollbarWidth:"none"}}>

            <iframe
                src={`${process.env.REACT_APP_NEOEDUCATION_BASE_URL}`}
                title="Neo Education"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
         </div>
        // </ParentComponent>

    );
};

export default EducationAndCertificate;